import './TabBar.css'

/**
 * Horizontal underline tabs — the legacy `nav-line-tabs nav-line-tabs-2x` strip that
 * sits in a list card's toolbar. The vertical `Tabs` rail is a different surface and
 * stays separate.
 *
 * @param {{id: string, label: string}[]} items
 */
export default function TabBar({ items, value, onChange, ariaLabel }) {
  return (
    <div className="tab-bar" role="tablist" aria-label={ariaLabel}>
      {items.map(({ id, label }) => {
        const selected = id === value
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={selected}
            className={`tab-bar__item${selected ? ' tab-bar__item--active' : ''}`}
            onClick={() => onChange(id)}
            data-testid="tab"
            data-tab-id={id}
          >
            <bdi>{label}</bdi>
          </button>
        )
      })}
    </div>
  )
}
